// State argument is not application state, only the state this reducer is responsible for
function tran(state = "", action) {
  switch (action.type) {
    case "SET_TRAN":
      return action.value;
    default:
      return state;
  }
}

export default tran;
